'use client';

import { PropsWithChildren, useEffect, useRef, useState } from 'react';
import clsx from 'clsx';

export type TextExpanderT = {
  showLess: string;
  readMore: string;
};

export function TextExpander({
  children,
  maxHeight = 150,
  className,
  disabled = false,
  defaultExpanded = false,
  t = { showLess: 'Show less', readMore: 'Read more' },
}: PropsWithChildren<{
  maxHeight?: number;
  className?: string;
  disabled?: boolean;
  defaultExpanded?: boolean;
  t?: TextExpanderT;
}>) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const [shouldShowButton, setShouldShowButton] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Check if content exceeds the max height
    if (textRef.current) {
      const contentHeight = textRef.current.scrollHeight;
      setShouldShowButton(contentHeight > maxHeight);
    }
  }, [children, maxHeight]);

  return (
    <div className={clsx('relative', className)}>
      <div
        ref={textRef}
        className="overflow-hidden transition-all duration-300 ease-in-out"
        style={{ maxHeight: isExpanded ? '100%' : `${maxHeight}px` }}
      >
        {children}
      </div>
      {shouldShowButton && !disabled && (
        <button
          type="button"
          onClick={() => setIsExpanded((prevState) => !prevState)}
          className="text-sm font-medium transition-colors hover:text-gray-600"
        >
          {isExpanded ? t?.showLess : t?.readMore}
        </button>
      )}
    </div>
  );
}
